import React from 'react';

const ActionButton = ({ icon, onClick, altText = "Icon", className = "" }) => {
  return (
    <button className={`btn btn-link border-0 p-0 ${className}`} onClick={onClick}>
      <img src={icon} alt={altText} />
    </button>
  );
};

export default ActionButton;
